/**
 * 缓存前缀
 */
export const CACHE_PREFIX = 'seaart_sdk'
